import React from "react";
import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";
import { ThemeIntent } from "../types";

export type CtSectionSeparatorProps = {
  label: string;
  intent?: ThemeIntent | "dark" | "light";
};

const bem = new BemHelper("ct-section-separator");

function CtSectionSeparator({ label, intent = "light" }: CtSectionSeparatorProps) {
  return (
    <div className={classNames(bem.block(), bem.modifier(intent))}>
      <div className={bem.element("label")}>{label}</div>
      <div className={bem.element("separator")}></div>
    </div>
  );
}

export default CtSectionSeparator;
